import {START_PROXY_ACTION} from '../actions/start-proxy-action';
import {END_PROXY_ACTION} from '../actions/end-proxy-action';

const openedProxyActions = {};

export const onProxyActionEndMiddleware = () => {
  return next => action => {
    if (action.type === START_PROXY_ACTION) {
      const {__resolvePromise__, __correlationId__} = action.payload;
      if (__resolvePromise__) {
        openedProxyActions[__correlationId__] = __resolvePromise__;
        delete action.payload.__resolvePromise__;
      }
    }

    if (action.type === END_PROXY_ACTION) {
      const {__resolveProps__, __correlationId__} = action.payload;
      if (openedProxyActions[__correlationId__]) {
        openedProxyActions[__correlationId__](__resolveProps__);
        delete openedProxyActions[__correlationId__];
      }
    }

    next(action);
  };
};
